import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, InputAdornment, Stack, Typography } from "@mui/material";
import moment from 'moment';
import { connect } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import Label from "../../../components/Common/Label";
import Notification from "../../../components/Common/Notification";
import Table from "../../../components/Common/Table";
import CheckBox from "../../../components/Form/CheckBox";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomTextField from "../../../components/Form/CustomTextField";
import Helpers from "../../../helpers/helpers";
import "../../Orders/order.css";
import DiscountField from "./DiscountField";

const Pricing = ({ setFormValues, values, error, isDifferentPrice, setIsDifferentPrice }) => {

  const [openDiscountField, setOpenDiscountField] = useState(false)
  const [editId, setEditId] = useState("")
  const [edit, setEdit] = useState(false)
  const [errorPrice, setError] = useState(false)
  const [errorDate, setErrorDate] = useState(false)
  const [errorQty, setErrorQty] = useState(false)
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [tempDiscount, setTempDiscount] = useState({
    discount_type: "",
    discount_value: "",
    discount_start: "",
    discount_end: "",
    min_purchase_qty: "",
    max_purchase_qty: "",
    is_ariba_discount: "",
    is_aspeed_discount: "",
  })

  const [tempDiscountEmpty, setTempDiscountEmpty] = useState({
    discount_type: "",
    discount_value: "",
    discount_start: "",
    discount_end: "",
    min_purchase_qty: "",
    max_purchase_qty: "",
    is_ariba_discount: "",
    is_aspeed_discount: "",
  })

  const [pricingData, setPricingData] = useState([
    { platform: "Aspeed", customer_group: "Standard, VIP", base_price: values?.product_price_groups?.filter((x, idx) => x.customer_group_id === 1).map((y) => y.price) },
    { platform: "Ariba", customer_group: "-", base_price: values?.ariba_price }
  ])
  const [pricingDataByCustomerGrp, setPricingDataByCustomerGrp] = useState([
    { platform: "Aspeed", customer_group: "Standard", base_price: values?.product_price_groups?.filter((x, idx) => x.customer_group_id === 1).map((y) => y.price) },
    { platform: "Aspeed", customer_group: "VIP", base_price: values?.product_price_groups?.filter((x, idx) => x.customer_group_id === 2).map((y) => y.price) },
    { platform: "Ariba", customer_group: "-", base_price: values?.ariba_price }
  ])

  useEffect(() => {
    setPricingData([
      { platform: "Aspeed", customer_group: "Standard, VIP", base_price: values?.product_price_groups?.filter((x, idx) => x.customer_group_id === 1).map((y) => y.price) },
      { platform: "Ariba", customer_group: "-", base_price: values?.ariba_price }
    ])
    setPricingDataByCustomerGrp([
      { platform: "Aspeed", customer_group: "Standard", base_price: values?.product_price_groups?.filter((x, idx) => x.customer_group_id === 1).map((y) => y.price) },
      { platform: "Aspeed", customer_group: "VIP", base_price: values?.product_price_groups?.filter((x, idx) => x.customer_group_id === 2).map((y) => y.price) },
      { platform: "Ariba", customer_group: "-", base_price: values?.ariba_price }
    ])

    // if (values?.product_price_groups) {
    //   if (values?.product_price_groups?.[0]?.price !== values?.product_price_groups?.[1]?.price) {
    //     setIsDifferentPrice(true)
    //   } else {
    //     setIsDifferentPrice(false)
    //   }
    // }

  }, [values?.ariba_price, values?.product_price_groups]);

  const princingHeader = [
    {
      Header: "Platform",
      accessor: (cellProps) => {
        return (<div className="d-flex align-items-center" style={{ minHeight: 53 }}>{cellProps?.platform || '-'}</div>)
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Customer Group",
      accessor: (cellProps) => {
        return (<div className="d-flex align-items-center" style={{ minHeight: 53 }}>{cellProps?.customer_group || '-'}</div>)
      },
    },
    {
      Header: "Base price",
      accessor: (cellProps, idx) => {
        return (
          <>
            <CustomTextField
              width={"100px"}
              values={cellProps?.base_price || ""}
              error={error?.[`product_price_groups.${idx}.price`]?.[0] && !cellProps?.base_price?.[idx] ? "The base price field is required." : (error && cellProps?.base_price === "") && error?.ariba_price}
              onChange={(e) => handleBasePriceChange(e, idx, cellProps?.platform, cellProps?.customer_group)}
              InputProps={{
                startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
              }}
              type="price"
              placeholder="0.00"
            />
          </>

        )
      },
    },
  ]

  const handleDeleteFiles = (id) => {
    const tempFile = values?.product_discounts
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id !== idx
    )
    // setSelectedDiscountItem(filteredFIle);
    setFormValues((prevValues) => ({
      ...prevValues,
      product_discounts: filteredFIle
    }))
  }

  const handleEditFiles = (id) => {
    const tempFile = values?.product_discounts
    setEdit(true)
    setEditId(id)
    const filteredFIle = tempFile && tempFile?.length > 0 && tempFile.filter((x, idx) =>
      id === idx
    )
    setOpenDiscountField(false)
    setTempDiscount(filteredFIle?.[0])
  }

  const handleBasePriceChange = (e, index, platform, customerGroup) => {
    if (platform === "Aspeed" && customerGroup === "Standard") {
      const temp = values?.product_price_groups || [];

      const updatedTemp = temp.map(x => ({
        ...x,
        price: x.customer_group_id === 1 ? e : x.price,
      }));


      setFormValues((prevValues) => ({
        ...prevValues,
        product_price_groups: updatedTemp
      }))
    } else if (platform === "Aspeed" && customerGroup === "VIP") {
      const temp = values?.product_price_groups || [];

      const updatedTemp = temp.map(x => ({
        ...x,
        price: x.customer_group_id === 2 ? e : x.price,
      }));


      setFormValues((prevValues) => ({
        ...prevValues,
        product_price_groups: updatedTemp
      }))
    } else if (platform === "Aspeed" && customerGroup === "Standard, VIP") {
      let temp = [
        {
          customer_group_id: 1,
          price: e
        },
        {
          customer_group_id: 2,
          price: e
        }
      ]
      setFormValues((prevValues) => ({
        ...prevValues,
        product_price_groups: temp
      }))
    } else if (platform === "Ariba") {
      setFormValues((prevValues) => ({
        ...prevValues,
        ariba_price: e
      }))
    }
  }

  const handleSaveEdit = (id) => {
    let error = checkingEmpty(tempDiscount)
    let errorDate = checkingDate(tempDiscount)
    let errorQty = checkingQty(tempDiscount)
    if (!error && !errorDate && !errorQty) {

      setEditId(id)
      setFormValues((prevValues) => {
        const updatedDiscounts = [...prevValues?.product_discounts];
        updatedDiscounts[id] = {
          ...updatedDiscounts[id],
          discount_type: tempDiscount?.discount_type,
          discount_value: tempDiscount?.discount_value,
          discount_start: tempDiscount?.discount_start,
          discount_end: tempDiscount?.discount_end,
          min_purchase_qty: tempDiscount?.min_purchase_qty,
          max_purchase_qty: tempDiscount?.max_purchase_qty,
          is_ariba_discount: tempDiscount?.is_ariba_discount,
          is_aspeed_discount: tempDiscount?.is_aspeed_discount,
        };

        return {
          ...prevValues,
          product_discounts: updatedDiscounts,
        };
      });
      setTempDiscount({
        discount_type: "",
        discount_value: "",
        discount_start: "",
        discount_end: "",
        min_purchase_qty: "",
        max_purchase_qty: "",
        is_ariba_discount: "",
        is_aspeed_discount: "",
      })
      setEditId("")
      setEdit(false)
    }
  }

  const checkingEmpty = (data) => {
    if (
      !data?.discount_type ||
      data?.discount_value === undefined ||
      data?.discount_value === null ||
      data?.discount_value === "" ||
      !data?.discount_start ||
      !data?.discount_end ||
      !data?.min_purchase_qty ||
      !data?.max_purchase_qty
    ) {
      setError(true);
      setErrorDate(false);
      setErrorQty(false);
      setNotification({
        open: true,
        msg: "Please complete discount section!",
        type: "warning",
      });
      return true;
    }

    setError(false);
    return false;
  };

  const checkingDate = (data) => {
    if (data?.discount_start && data?.discount_end && (data?.discount_start > data?.discount_end)) {
      setErrorDate(true)
      setError(false)
      setErrorQty(false)
      setNotification({
        open: true,
        msg: "The discount end date date must be a date after discount start date!",
        type: "warning",
      });
      return true
    }
    setErrorDate(false)
    return false
  }

  const checkingQty = (data) => {
    if (data?.min_purchase_qty <= 0) {
      setErrorQty(true)
      setErrorDate(false)
      setError(false)
      setNotification({
        open: true,
        msg: "The min purchase quantity field must be at least 1.",
        type: "warning",
      });
      return true
    } else if (data?.min_purchase_qty && data?.max_purchase_qty && (data?.min_purchase_qty > data?.max_purchase_qty)) {
      setErrorQty(true)
      setErrorDate(false)
      setError(false)
      setNotification({
        open: true,
        msg: "The max purchase quantity must more than the min purchase quantity!",
        type: "warning",
      });
      return true
    }
    setErrorQty(false)
    return false

  }

  const handleAddDiscount = () => {
    let error = checkingEmpty(tempDiscountEmpty)
    let errorDate = checkingDate(tempDiscountEmpty)
    let errorQty = checkingQty(tempDiscountEmpty)
    if (!error && !errorDate && !errorQty) {
      let temp = values?.product_discounts || []
      temp.push(tempDiscountEmpty)
      setFormValues((prevValues) => ({
        ...prevValues,
        product_discounts: temp
      }))
      setTempDiscountEmpty({
        discount_type: "",
        discount_value: "",
        discount_start: "",
        discount_end: "",
        min_purchase_qty: "",
        max_purchase_qty: "",
        is_ariba_discount: "",
        is_aspeed_discount: "",
      })
      // clearError()
      setOpenDiscountField(false)
    }
  }

  const handleSetDifferent = (e) => {
    setIsDifferentPrice(e.target.checked)
    if (!e.target.checked) {
      const temp = values?.product_price_groups || [];
      let price = temp.filter((x) => x?.customer_group_id === 1).map((y) => y?.price)

      const updatedTemp = temp.map(x => ({
        ...x,
        price: x?.customer_group_id === 2 ? price?.[0] : x.price,
      }));

      setFormValues((prevValues) => ({
        ...prevValues,
        product_price_groups: updatedTemp
      }))
    }
  }

  return (
    <React.Fragment>
      <Notification notification={notification} setNotification={setNotification} />
      <Card className="p-3 px-2">
        <CardBody>
          <div className="setting-header">PRICING</div>
          {error && <FormHelperText sx={{ color: "red" }}>{error.product_price_groups || ""}</FormHelperText>}

          <Divider className="my-2 mb-4" />
          <Stack display={"grid"}>
            <Table
              header={princingHeader}
              data={isDifferentPrice ? pricingDataByCustomerGrp : pricingData}
              totalPage={1}
              pageSize={10}
              customToolsBar={true}
            />
          </Stack>

          <CheckBox
            label={'Set different prices for customer groups (A-Speed E-commerce only)'}
            values={isDifferentPrice}
            onChange={(e) => handleSetDifferent(e)}
          />
          <Divider className="my-2 mb-4 mt-4" />
          <span className="" style={{ fontFamily: 'Manrope', fontSize: 14, fontWeight: 600, color: "#282828" }}>Discounts (optional)</span>
          {error && <FormHelperText sx={{ color: "red" }}>{error && error?.product_discounts}</FormHelperText>}
          <Stack direction={{ sm: "row", xs: "column" }} pt={2} gap={1} justifyContent={"space-between"} pb={2}>
            <Stack direction={"row"} gap={1}>
              <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <i className="ri-price-tag-3-line" style={{ fontSize: "24px" }}></i>
              </div>
              <div>
                <span className="setting-form-section-header" >Discounts</span>
                <Typography><span className="setting-form-subtitle">{values?.product_discounts?.length} Discounts</span></Typography>
              </div>
            </Stack>
            <Stack display={"contents"} justifyContent={{ xs: "flex-start", sm: "flex-end" }}>
              <CustomButton
                borderStyle={"1px solid #282828"}
                title={"Add discount"}
                press={() => (setOpenDiscountField(true), setEditId(""), setEdit(false))}
                height={40}
                backgroundColor={'white'}
                textColor={'#282828'}
              />
            </Stack>
          </Stack>
          <div
            className="dropzone-previews"
            id="file-previews"
          >
            <Stack spacing={1} mt={{ sm: 3, xs: 1 }}>
              {values?.product_discounts && values?.product_discounts.length > 0 && values?.product_discounts.map((f, i) => {
                return (
                  <div key={i}>
                    {
                      <div
                        className="mb-0"
                        key={i + "-file"}
                        style={{ border: "1px solid #d0d0d0", padding: "10px", borderRadius: "8px", paddingTop: "15px", paddingBottom: "15px" }}
                      >
                        <Stack flexDirection={{ xs: "column", sm: "row" }} justifyContent={"space-between"}>
                          <div className="p-2">
                            <Stack direction={"row"} spacing={1} gap={1}>
                              <span className="" style={{ fontFamily: 'Manrope', fontSize: 14, fontWeight: 600, color: "#282828" }}>
                                Discount: {f.discount_type == "fixed" && "S$"} {f.discount_value} {f.discount_type == "percentage" && "%"} Off
                              </span>
                              {f.is_ariba_discount === 1 && <Label.CustomLabel label={'Ariba'} color={"#2563eb"} backgroundColor={"#dbeafe"} />}
                              {f.is_aspeed_discount === 1 && <Label.CustomLabel label={'Aspeed'} color={"#FF3838"} backgroundColor={"#FFF5F4"} />}
                            </Stack>
                            <Typography><span className="setting-form-subtitle">Duration: {moment(f.discount_start).format("DD MMM YYYY")} - {moment(f.discount_end).format("DD MMM YYYY")} </span></Typography>
                            {error &&
                              <FormHelperText sx={{ color: "red" }}>
                                {error && (Helpers?.getCustomSpecificErrorMessageSpec(error, `product_discounts.${i}.discount_value`) !== "" ?
                                  Helpers?.getCustomSpecificErrorMessageSpec(error, `product_discounts.${i}.discount_value`)
                                  : Helpers?.getCustomErrorMessageByPrefix(error, "product_discounts."))}
                              </FormHelperText>}
                          </div>
                          <div className="d-flex flex-row justify-content-end">
                            <div className="justify-content-end">
                              <CustomIconButton
                                iconName={'ri-pencil-line'}
                                onClick={(e) => handleEditFiles(i)} />
                            </div>
                            <div className="justify-content-end">
                              <CustomIconButton
                                iconName={'ri-delete-bin-line'}
                                onClick={(e) => handleDeleteFiles(i)}
                                backgroundColor={'#ED1A3D'}
                                color={'white'}
                                borderStyle={"1px solid #ED1A3D"}
                              />
                            </div>

                          </div>

                        </Stack>
                      </div>
                    }{
                      edit && editId === i &&
                      <DiscountField setNotification={setNotification} setOpenDiscountField={setOpenDiscountField} tempDiscount={tempDiscount} error={errorPrice} errorDate={errorDate} errorQty={errorQty} setTempDiscount={setTempDiscount}
                        handleAddDiscount={handleAddDiscount} edit={edit} setEditId={setEditId} handleSaveEdit={handleSaveEdit} id={i} setEdit={setEdit}
                        setError={setError} setErrorDate={setErrorDate} setErrorQty={setErrorQty} />
                    }
                  </div>

                );
              })}
            </Stack>

            {
              openDiscountField &&
              <DiscountField setOpenDiscountField={setOpenDiscountField} tempDiscount={tempDiscountEmpty} error={errorPrice} errorDate={errorDate} errorQty={errorQty}
                setTempDiscount={setTempDiscountEmpty} handleAddDiscount={handleAddDiscount} edit={false} setEditId={setEditId}
                setError={setError} setErrorDate={setErrorDate} setErrorQty={setErrorQty} />
            }
          </div>
        </CardBody>
      </Card>
    </React.Fragment >
  );
};

function mapStateToProps({ }) {
  return {

  };
}


export default connect(mapStateToProps)(Pricing);
